import { makeStyles } from '@mui/styles';
import { colors } from '../../../../../packages/colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    height: 'calc(100vh - 240px)',
    overflowY: 'auto',
    // backgroundColor: colors.white,
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  sectionTitle: {
    fontSize: 18,
    color: colors.neutral800,
  },
  inputsBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
  },
  searchInput: {
    flex: 1,
    backgroundColor: colors.white,
    '& .MuiInputBase-root': {
      backgroundColor: colors.white,
    },
  },
  zipCodeInput: {
    backgroundColor: colors.white,
    '& .MuiInputBase-root': {
      backgroundColor: colors.white,
    },
  },
  pharmacyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    overflowY: 'auto',
  },
  pharmacyItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    border: `1px solid ${colors.neutral100}`,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: colors.white,
    '&:hover': {
      borderColor: colors.primary500,
      backgroundColor: colors.neutral25,
    },
  },
  selectedPharmacy: {
    borderColor: colors.success500,
    backgroundColor: colors.success50,
    '&:hover': {
      borderColor: colors.success500,
      backgroundColor: colors.success100,
    },
  },
  pharmacyInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
  },
  pharmacyName: {
    fontSize: 16,
    color: colors.neutral800,
    fontWeight: 600,
  },
  pharmacyAddress: {
    fontSize: 14,
    color: colors.neutral600,
  },
  pharmacyPhone: {
    fontSize: 13,
    color: colors.neutral600,
  },
  pharmacyFeature: {
    fontSize: 12,
    color: colors.success600,
    fontWeight: 500,
  },
  selectedIcon: {
    marginLeft: 12,
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 40,
    color: colors.neutral600,
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
    color: colors.neutral600,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.primary25,
    borderRadius: 8,
    border: `1px solid ${colors.primary100}`,
    padding: '16px 24px',
    gap: 16,
  },
  infoCard: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
    borderRadius: 8,
    border: `1px solid ${colors.neutral100}`,
    padding: 16,
    gap: 8,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: colors.neutral800,
    lineHeight: '20px',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  memberAddressText: {
    fontSize: 13,
    color: colors.neutral800,
    lineHeight: '16px',
  },
  prescriptionItem: {
    fontSize: 13,
    color: colors.neutral800,
    lineHeight: '16px',
  },
});
